<template>
    <div class="about-rp">
        <h3 class="indent">Casting</h3>
        <p class="indent">To cover the needs of its rolling production, Alcomet has a
          casthouse equipped with 7 continuous casting lines with a total
          production capacity of 96 000 tons per year. Main focus is on 1xxx,
          8xxx, 3xxx and 5xxx series alloys suitable for the majority of foil
          products available on the market, as well as many kinds of sheets
          and strips for industrial applications.</p>
        <p class="indent">Chemical composition is according to international standards,
          such as EN 573-3, or internal standards developed specifically to
          ensure best possible quality of the final product.</p>
        <div class="about-rp-table">
          <div class="about-rp-table-row">
            <span>Strip thickness:</span>
            <span>5 - 10 mm</span>
          </div>
          <div class="about-rp-table-row">
            <span>Strip width:</span>
            <span>max. 1800 mm</span>
          </div>
          <div class="about-rp-table-row">
            <span>Available alloys:</span>
            <span>1xxx, 3xxx, 5xxx, 8xxx series</span>
          </div>
        </div>
        <img class="about-rp-img" src="/static/img/about/rp/1.jpg" alt="Rolling">
        <h3 class="indent">Rolling</h3>
        <p class="indent">The main production division at Alcomet is the Rolling
          plant equipped with a cold-rolling mill, a foil-breakdown
          mill and 3 foil mills. Our state-of-the-art finishing lines for
          slitting, degreasing, cut-tolength and embossing enable
          the company to produce a wide range of products with
          a variety of applications in food packaging, construction,
          automotive, heat exchangers, etc. Company’s primary
          focus are foil products such as household foil, converter
          foil, container foil and technical foil with annual production
          output of over 40 000 tons, making Alcomet a leading
          European supplier of these products.</p>
        <p class="indent">Strong demand for Alcomet’s rolled products led to the
          opening of Rolling plant 2 in 2021 with core equipment
          a new 6-high cold-rolling mill built by the German SMS
          Group. Total rolling capacity of both Rolling plants
          amounts to 100 000 tons per year. Today the company is
          able to offer rolled products with max width of 2200mm.
          New equipments Cut to Length and Slitter were installed
          in Rolling plant 2, thanks to which is performing precision
          processing of the rolled products.</p>
        <img class="about-rp-img" src="/static/img/about/rp/2.jpg" alt="Rolling">
        <app-share-button></app-share-button>
    </div>
</template>

<script>
import ShareButton from "../shared/ShareButton";
export default {
  components: {
    appShareButton: ShareButton
  }
};
</script>

<style scoped>
.about-rp {
  align-items: center;
  display: flex;
  flex-direction: column;
}
.about-rp > p {
  font-size: 19px;
  line-height: 32px;
  margin: 15px auto;
  text-align: justify;
  width: 60%;
}
.about-rp > h3 {
  font-size: 22px;
  font-weight: 500;
  line-height: 32px;
  margin: 15px auto;
  text-align: justify;
  width: 60%;
}
.about-rp-table {
  margin: 15px 0;
  width: 60%;
}
.about-rp-table-row {
  align-items: center;
  background-color: #eef2f8;
  border-radius: 6px;
  display: flex;
  height: 50px;
  justify-content: space-between;
  margin-bottom: 8px;
  padding: 0 20px;
  width: 100%;
}
.about-rp-table-row > span {
  font-weight: 700;
  font-size: 16px;
  color: #1a437c;
}
.about-rp-img {
  border-radius: 5px;
  height: auto;
  margin: 20px auto;
  min-height: 1px;
  width: 80%;
}
@media screen and (max-width: 1000px) {
  .about-rp p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
  .about-rp-table,
  .about-rp > h3 {
    width: 100%;
    padding: 0 30px;
  }
  .about-rp-img {
    width: calc(100% - 60px);
  }
}
@media screen and (max-width: 600px) {
  .about-rp-table-row > span {
    font-size: 12px;
  }
  .about-rp-table-row > span:last-child {
    text-align: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/about/RollingPlant.vue